import { FaExclamationCircle, FaCheck } from 'react-icons/fa';
import { ImBlocked } from 'react-icons/im';

export const VisitBadge = ({ status, statuses }) => {
  if (statuses) {
    const notOk = statuses.filter((it) => it != 'ok');
    if (notOk.length) {
      status = notOk[0];
    } else if (statuses.length) {
      status = statuses[0];
    }
  }

  const body =
    {
      ok: <FaCheck size={12} />,
      block: <ImBlocked size={14} />,
      error: <FaExclamationCircle size={14} />,
    }[status] || status;
  return <div>{body}</div>;
};
